define([
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "underscore",
  "postal",
  "pricing-support",
  "local-storage",
  "js-cookie",
  "knockout-postbox"],
  function (globals, baseViewModel, $, ko, _, postal, PricingSupport, LocalStorage, Cookies) {

    var productPageChannel = postal.channel("productpage");

    var ProductPriceViewModel = function (parentModel, sizeOptions) {

      var self = this;
      var parent = parentModel;
      ko.utils.extend(self, baseViewModel);

      self.defaultPrice = globals.price;
      self.productId = globals.productId;
      self.widthOption = globals.models.widthOption;
      self.heightOption = globals.models.heightOption;
      self.sampleOptions = globals.models.sampleOptions;
      self.oldPricingContext = undefined;

      var strikethroughPriceModel = globals.models.strikethroughPrice;
      /*
        Not really sure how to introduce strike through price model as an observable withouth disrupting PriceSubModel.
        Therefore I ended up with creating individual properties against product price view model.
      */

      if (strikethroughPriceModel) {
        self.discountPrice = ko.observable(strikethroughPriceModel.Price);
        self.originalPrice = ko.observable(strikethroughPriceModel.OriginalPrice);
        self.strikethroughMessage = ko.observable(strikethroughPriceModel.StrikethroughMessage);
        self.stackablePercentage = ko.observable();
      }

      self.defaults = {
        minWidth: 7,
        maxWidth: 156,
        minHeight: 10,
        maxHeight: 160
      };

      if (globals.isMandi) {
        let postMeasureCookie = Cookies.get("postMeasureOptions");
        if (postMeasureCookie) {
          let postMeasureOptions = JSON.parse(postMeasureCookie);
          Cookies.set("widthz", postMeasureOptions.Width);
          Cookies.set("hghtz", postMeasureOptions.Height);
        }
      }

      self.sizeOptions = $.extend({}, self.defaults, sizeOptions);
      self.widthDimension = new PricingSupport.WidthDimension(self.sizeOptions.minWidth, self.sizeOptions.maxWidth);
      self.heightDimension = new PricingSupport.HeightDimension(self.sizeOptions.minHeight, self.sizeOptions.maxHeight);

      self.price = ko.observable(globals.price).publishOn("colorSelectorPrice");
      self.widthWhole = ko.observable(self.widthDimension.dimension.valueWhole());
      self.widthEighths = ko.observable(self.widthDimension.dimension.valueEighths());
      self.heightWhole = ko.observable(self.heightDimension.dimension.valueWhole());
      self.heightEighths = ko.observable(self.heightDimension.dimension.valueEighths());
      self.currentChoiceIds = ko.observableArray();
      self.dimensionsAdjustedByServer = ko.observable(globals.dimensionsAdjusted);

      self.widthWhole.subscribe(function (newValue) {
        self.widthDimension.dimension.valueWhole(newValue);
      });
      self.widthEighths.subscribe(function (newValue) {
        self.widthDimension.dimension.valueEighths(newValue);
      });
      self.heightWhole.subscribe(function (newValue) {
        self.heightDimension.dimension.valueWhole(newValue);
      });
      self.heightEighths.subscribe(function (newValue) {
        self.heightDimension.dimension.valueEighths(newValue);
      });
      self.isLoadingPrices = ko.observable(false);

      self.onDimensionsChanged = function (data, e) {

        self.updateWholeEighths(data, e.target);
        self.publishDimensionsChangedEvent();
        updatePrice(data, e);

        self.dimensionsAdjustedByServer(false);
      };

      self.updateWholeEighths = function (data, target) {
        // Prevent user from selecting eighths of inches past maximum whole value.
        if ($(target).hasClass("gcc-dimension-whole")) {
          var maxDimension, currentWholeDimension;
          if ($(target).data("testid") == "heightWhole") {
            maxDimension = data.heightDimension.dimension.maxDimension;
            currentWholeDimension = data.heightDimension.dimension.valueWhole();
          } else if ($(target).data("testid") == "widthWhole") {
            maxDimension = data.widthDimension.dimension.maxDimension;
            currentWholeDimension = data.widthDimension.dimension.valueWhole();
          }
          var objEighths = $(target).parent(".bdc-dropdown").next(".bdc-dropdown").find(".gcc-dimension-eighths");
          if (maxDimension == currentWholeDimension) {
            if ($(target).data("testid") == "heightWhole") {
              self.heightEighths(0);
            } else if ($(target).data("testid") == "widthWhole") {
              self.widthEighths(0);
            }
            objEighths.prop("disabled", "disabled");
          } else {
            objEighths.prop("disabled", false);
          }
        }
      };
      self.formattedEighths = [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 },
      { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 },
      { name: "3/4", value: 6 }, { name: "7/8", value: 7 }];
      self.formattedWidthEighths = ko.computed(function () {
        if (self.widthEighths() === 0)
          return "";
        else {
          let data = _.find(self.formattedEighths, function (formatted) {
            return formatted.value === self.widthEighths();
          });
          if (data) {
            return data.name + "\xa0";
          }
          return "";
        }
      });

      self.formattedHeightEighths = ko.computed(function () {
        if (self.heightEighths() === 0)
          return "";
        else {
          let data = _.find(self.formattedEighths, function (formatted) {
            return formatted.value === self.heightEighths();
          });
          if (data) {
            return data.name + "\xa0";
          }
          return "";
        }
      });

      $(document).ready(function () {
        updatePrice();
      });

      function updatePrice(data, e, callback) {
        var params = buildPricingContext();

        $.ajax({
          url: globals.paths.loadSiteProductPricingWithColors,
          type: "GET",
          contentType: "application/json; charset=utf-8",
          data: {
            selectedPricingContext: JSON.stringify(params),
            productId: self.productId,
            siteId: globals.siteId,
            width: self.widthDimension.dimension.value(),
            height: self.heightDimension.dimension.value(),
            calculateColorChoicePrices: globals.displayPriceFlags
          }
        })
          .done(function (result, status, xhr) {
            if (result.Data.SelectedPrice) {
              if (result.Data.ForCurrentContext == "0") {
                self.price("N/A");
              } else {
                var data = result.Data;
                self.price(data.SelectedPrice.toFixed(2));

                self.discountPrice(data.StrikethroughPrice.Price);
                self.originalPrice(data.StrikethroughPrice.OriginalPrice);
                self.strikethroughMessage(data.StrikethroughPrice.Message ? data.StrikethroughPrice.Message.toLowerCase() : "");
                self.stackablePercentage(data.StackablePromo ? data.StackablePromo.Amount : 0);
              }
              xhr.status = "success";
            } else {
              self.price("N/A");
              xhr.status = "failure";
            }

            var productPageChannel = postal.channel("productpage");
            for (var i = 0; i < result.Data.ColorChoicePrices.length; i++) {
              var colorChoicePrice = result.Data.ColorChoicePrices[i];
              productPageChannel.publish("choice.price.updated", { choiceId: colorChoicePrice.ChoiceId, price: colorChoicePrice.Price });
            }
            UpdateProductPreviewMicroApp(data);
          })
          .then(function () {
            var price = self.price();
            if (isNaN(price)) {
              // If price if not defined, we use default price from view
              price = self.defaultPrice;
            }
            price = parseFloat(price).toFixed(2);
            postal.publish({
              channel: "productpage",
              topic: "product.price.loaded",
              data: {
                price: price
              }
            });

            // Update price for sticky header
            var updatePriceEvent = new CustomEvent("price-updated", {
              detail: {
                price,
              }
            });
            dispatchEvent(updatePriceEvent);

          }).always(function () {
            if ($.isFunction(callback)) {
              callback();
            }
          }).fail(function () {
            self.price("N/A");
          });
      }

      function UpdateProductPreviewMicroApp(data) {
        const detail = {
          price: {
            originalPrice: data.StrikethroughPrice.OriginalPrice,
            percentOff: data.StrikethroughPrice.Percentage,
            promoDescription: data.StrikethroughPrice.Message,
            stackablePercentOff: data.StackablePromo ? data.StackablePromo.Amount : 0,
          },
        };

        window.dispatchEvent(new CustomEvent('product-preview', { bubbles: false, cancelable: true, detail }));
      }

      var buildPricingContext = function () {
        var localPersistance = new LocalStorage();
        var savedState = localPersistance.getFromLocalStorage("option-state-" + self.productId);
        if (savedState) {
          var selectedChoices = JSON.parse(savedState);
          var selectedChoiceIds = [];
          _.each(selectedChoices, function (sc) {
            // Add to the collection only the sampleable choices
            if (sc.id !== self.widthOption.ChoiceId && sc.id !== self.heightOption.ChoiceId) {
              selectedChoiceIds.push(sc.id);
            }
          });
        }

        var params = {
          "ProductId": self.productId,
          "Choices": [],
          "ForContextOnly": true
        };

        // Width
        if (self.widthOption !== null) {
          params.Choices.push({
            ChoiceId: self.widthOption.ChoiceId,
            OptionId: self.widthOption.OptionId,
            OptionType: "width",
            ChoiceValue: self.widthDimension.dimension.value()
          });
        }

        // Height
        if (self.heightOption !== null) {
          params.Choices.push({
            ChoiceId: self.heightOption.ChoiceId,
            OptionId: self.heightOption.OptionId,
            OptionType: "height",
            ChoiceValue: self.heightDimension.dimension.value()
          });
        }

        // Samples (mostly colors)
        if (selectedChoiceIds) {
          _.each(self.sampleOptions.Options, function (sampleOption) {
            var optionType = sampleOption.Type ? sampleOption.Type.replace(" ", "").toLowerCase() : "";
            _.each(sampleOption.Groups, function (group) {
              _.each(group.Choices, function (choice) {
                if (_.contains(selectedChoiceIds, choice.ChoiceId)) {
                  params.Choices.push({
                    ChoiceId: choice.ChoiceId,
                    OptionId: sampleOption.OptionId,
                    OptionType: optionType,
                    ChoiceValue: true
                  });
                  var index = selectedChoiceIds.indexOf(choice.ChoiceId);
                  if (index > -1) selectedChoiceIds.splice(index, 1);
                }

                if (!selectedChoiceIds.length) {
                  return params;
                }
              });
            });
          });
        }
        return params;
      };

      var getSampleOptionIds = function () {

        // Samples (mostlye colors)
        var params = [];
        _.each(self.sampleOptions, function (sampleOption) {
          params.push(sampleOption.OptionId);
        });

        return params;
      };

      var SamePricingContex = function (newPricingContext) {
        if (self.oldPricingContext && newPricingContext) {
          if (self.oldPricingContext.ProductId === newPricingContext.ProductId &&
            self.oldPricingContext.ForContextOnly === newPricingContext.ForContextOnly &&
            self.oldPricingContext.Choices.length === newPricingContext.Choices.length) {
            for (var i = 0, j = newPricingContext.Choices.length; i < j; i++) {
              var newChoice = newPricingContext.Choices[i];
              var oldChoice = self.oldPricingContext.Choices[i];
              if (newChoice.ChoiceId !== oldChoice.ChoiceId ||
                newChoice.OptionId !== oldChoice.OptionId ||
                newChoice.OptionType !== oldChoice.OptionType ||
                newChoice.ChoiceValue !== oldChoice.ChoiceValue) {
                return false;
              }
            }
            return true;
          }
        }
        return false;
      };

      self.publishDimensionsChangedEvent = function () {
        postal.publish({
          topic: "dimensions.changed",
          data: {
            pricingContext: buildPricingContext(),
            optionIds: getSampleOptionIds(),
            productId: self.productId,
            width: self.widthDimension,
            height: self.heightDimension
          }
        });
      };

      //usage numericPrice: field
      //if there is a decimal portion, show two decimal places.  If not, show 0 decimal places.
      ko.bindingHandlers.numericPrice = {
        update: function (element, valueAccessor, allBindingsAccessor) {
          var value = ko.utils.unwrapObservable(valueAccessor()),
            precision = value % 1 === 0 ? 0 : 2,
            formattedValue = value.toFixed(precision);

          ko.bindingHandlers.text.update(element, function () { return formattedValue; });
        },
        defaultPrecision: 1
      };

      productPageChannel.subscribe({
        topic: 'react.dimension.changed',
        callback: function (data) {
          var pricing = data.pricing;

          var price = pricing.price !== pricing.strikeThroughPricingModel.originalPrice
            ? pricing.strikeThroughPricingModel.originalPrice
            : pricing.price;

          self.price(price);

          self.discountPrice(pricing.strikeThroughPricingModel.discountPrice);
          self.originalPrice(pricing.strikeThroughPricingModel.originalPrice);
          self.strikethroughMessage(pricing.strikeThroughPricingModel.message ? pricing.strikeThroughPricingModel.message.toLowerCase() : "");
        }
      });

      productPageChannel.subscribe({
        topic: 'react.no.price',
        callback: function () {
          self.price('N/A');
        }
      });

      document.addEventListener("swatchSelected", (data, e) => updatePrice(data, e));
    };

    return ProductPriceViewModel;

  });
